import { useEffect, useState } from 'react';
import { apiServerDac } from '@/services/api';
import { IDisciplinaEletivaData } from '@/@types/Graduacao/DisciplinasEletivas';
import { DisciplinasEletivasComponent } from '@/components/PagesComponents/Graduacao/DisciplinasEletivas';

const DisciplinasEletivas = () => {
    const anoAtual = new Date().getFullYear();    
    const [data, setData] = useState<IDisciplinaEletivaData[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [ano, setAno] = useState<number>(anoAtual)

    useEffect(() => {
        // server-dac V2 substitui /disciplinas/allcatalogeletivas preservando { disciplinas }.
        const url = `/v2/disciplinas_catalogo/eletivas?ano=${!ano ? anoAtual : ano}&tipo=FA`

        setIsLoading(true);

        const getDisciplinasEletivasData = async () => {
            await apiServerDac.get(url)
                .then(response => {
                    const disciplinas = response.data.disciplinas.map((disciplina: any) => ({
                        ...disciplina,
                        COD_DISC: disciplina.COD_DISC || disciplina.COD_DISCI,
                        ANO_CATAL: disciplina.ANO_CATAL || disciplina.ano_catal,
                    }));
                    setData(disciplinas);
                    setIsLoading(false);
                })
                .catch(err => {
                    console.log(err);
                    setIsLoading(false);
                });
        };

        getDisciplinasEletivasData();
    }, [ano])

    return (
        <div>
            <h1>Graudação - Disciplinas Eletivas</h1>

            <DisciplinasEletivasComponent setAno={setAno} ano={ano} isLoading={isLoading} data={data} />
        </div>
    );
}

export { DisciplinasEletivas };
